import { FusionSuggestionRequestOptions } from "../../../models/search/fusion/fusion-suggestion-request-options.model";
import { FusionApiVersion } from "../../../models/search/fusion/fusion-versions";
import { fetchWith } from "../../fetch";

export class FusionSearchSuggestionHttpService {
  private static instance: FusionSearchSuggestionHttpService;

  private static createUrl(options: FusionSuggestionRequestOptions): string {
    const { appName, hostUrl, language, version } = options;
    const baseUrl: string =
      FusionSearchSuggestionHttpService.createFusionBaseUrl(version);
    const resource = `${appName}_${language}_suggest`;
    let application = appName;

    if (version === "v1") {
      return `${hostUrl}${baseUrl}/${application}/query/${resource}`;
    }

    return `${hostUrl}${baseUrl}/${application}_${language}/query/${resource}`;
  }

  private static createFusionBaseUrl(version: FusionApiVersion = "v3") {
    return `/portal-services/search/${version}/be/api/apps`;
  }

  private static createQueryParams(
    searchTerm: string,
    options: FusionSuggestionRequestOptions,
    isUserLoggedIn = false,
  ): Record<string, string> {
    const { instance, userGroup } = options;
    return {
      q: searchTerm,
      b: instance || "",
      "pex-g": userGroup,
      loggedIn: isUserLoggedIn.toString(),
      currentUrl: FusionSearchSuggestionHttpService.getCurrentUrl(),
    };
  }

  private constructor() {
    // Private constructor -> singleton
  }

  static getInstance(): FusionSearchSuggestionHttpService {
    if (!FusionSearchSuggestionHttpService.instance) {
      FusionSearchSuggestionHttpService.instance =
        new FusionSearchSuggestionHttpService();
    }
    return FusionSearchSuggestionHttpService.instance;
  }

  static getCurrentUrl(): string {
    let currentUrl = window.document.URL;
    if (currentUrl.indexOf("localhost") > -1) {
      const protocol = new URL(currentUrl).protocol;
      currentUrl = currentUrl.replace(`${protocol}//`, "");
    }

    return currentUrl;
  }

  /**
   * Perform a query for autocomplete terms.
   * Example: http://localhost:8764/api/apps/swisscom_portal/query/swisscom_portal_de_suggest?q=ip
   *
   * @param searchTerm string   */
  get(
    searchTerm: string,
    options: FusionSuggestionRequestOptions,
    isUserLoggedIn: boolean,
  ): Promise<any> {
    let url = FusionSearchSuggestionHttpService.createUrl(options);
    const params = FusionSearchSuggestionHttpService.createQueryParams(
      searchTerm,
      options,
      isUserLoggedIn,
    );
    return fetchWith(url, params, { credentials: "same-origin" }).then(
      res => res.body,
    );
  }
}
